import "./WhatsAppButton.css";
import { MessageCircle } from "lucide-react";
import { trackWhatsAppConversion } from "../utils/googleAds";

const WhatsAppButton = () => {

  const openWhatsApp = () => {

    // Track Google Ads conversion
    trackWhatsAppConversion();

    const phone = "919653304639";

    const message =
      "Hi, I'm interested in your development services. I'd like to know more.";

    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <button
      className="whatsapp-float"
      onClick={openWhatsApp}
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle size={30} />
    </button>
  );
};

export default WhatsAppButton;